import { fetchLocations } from "./fetchLocationAutocompleteSaga";
import { actionTypes } from "../actions";
import { takeLatest } from "redux-saga/effects";
import { fetchCalendarBucketsSaga } from "./fetchCalendarSaga";
import { fetchHasSeenVRAwarenessSaga } from "./fetchHasSeenVRAwarenessSaga";
import { updateHasSeenVRAwarenessSaga } from "./updateHasSeenVRAwarenessSaga";

export function* watchFetchLocationCategories() {
  yield takeLatest(actionTypes.FETCH_LOCATION_CATEGORIES, fetchLocations);
}

export function* watchFetchCalendarBucketsSaga() {
  yield takeLatest(
    actionTypes.FETCH_CALENDAR_BUCKETS,
    fetchCalendarBucketsSaga
  );
}

export function* watchFetchHasSeenVRAwarenessSaga() {
  yield takeLatest(
    actionTypes.FETCH_HAS_SEEN_VR_AWARENESS,
    fetchHasSeenVRAwarenessSaga
  );
}

export function* watchUpdateHasSeenVRAwarenessSaga() {
  yield takeLatest(
    actionTypes.UPDATE_HAS_SEEN_VR_AWARENESS,
    updateHasSeenVRAwarenessSaga
  );
}
